var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DateTime } from 'luxon';
export var DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export var DATE_NOT_VALID_FORMAT = 'DATE_NOT_VALID_FORMAT';
var defaultOptions = {
    defaultValue: DateTime.local().startOf('day').toJSDate(),
    format: DEFAULT_DATE_FORMAT,
};
/**
 *
 * @param date
 * @param options
 * @returns
 */
export var getInputDateObj = function (date, options) {
    if (options === void 0) { options = defaultOptions; }
    var _a = options.defaultValue, defaultValue = _a === void 0 ? defaultOptions.defaultValue : _a, _b = options.format, format = _b === void 0 ? defaultOptions.format : _b;
    var returnObj = {
        inputValue: '',
        value: '',
        date: defaultValue,
        valid: true,
    };
    // empty string is a valid date
    if (date === '') {
        returnObj = {
            inputValue: '',
            value: '',
            date: defaultValue,
            valid: true,
        };
    }
    else if (typeof date === 'string') {
        // non empty string
        // format and check if valid
        var d = DateTime.fromFormat(date, format);
        if (!d.isValid) {
            returnObj = {
                inputValue: date,
                value: date,
                date: defaultValue,
                valid: false,
            };
        }
        else {
            returnObj = {
                inputValue: date,
                value: d.toJSDate(),
                date: d.toJSDate(),
                valid: true,
            };
        }
    }
    else {
        // date variable was a Date object
        var d = DateTime.fromJSDate(date);
        returnObj = {
            inputValue: d.toFormat(format),
            value: date,
            // Keep calendar picker working by falling back on default value if date object is invalid
            date: d.isValid ? date : defaultValue,
            valid: d.isValid,
        };
    }
    // date's value is already a jsDate object, provide string format
    return returnObj;
};
var inputDateDiff = function (d1, d2) {
    return (d1 &&
        d2 &&
        d1.inputValue === d2.inputValue &&
        d1.date &&
        d2.date &&
        DateTime.fromJSDate(d1.date).diff(DateTime.fromJSDate(d2.date)).as('days'));
};
var inputDateReducer = function (state, action) {
    var options = (action === null || action === void 0 ? void 0 : action.options) || defaultOptions;
    var actionInputDate;
    var emptyInputDate;
    var daysDiff;
    switch (action.type) {
        case 'init':
        case 'update':
            actionInputDate = getInputDateObj(action.value || '', options);
            daysDiff = inputDateDiff(actionInputDate, state);
            if (daysDiff === 0) {
                return __assign({}, state);
            }
            return __assign({}, actionInputDate);
        case 'remove':
            emptyInputDate = getInputDateObj('', options);
            return __assign(__assign({}, state), emptyInputDate);
        default:
            throw new Error("inputDateReducer doesn't have type in action");
    }
};
export default inputDateReducer;
